// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_dH2","cls2":"DebugPage-cls2_UrM DebugPage-cls1_dH2"};